import { onViewLoad } from "~/jose_modern/on_view_load";
import { initializeInventoryAdjustPage } from "./shared/inventory_adjustments";
import { setupUnitChangeModal } from "./shared/inventory_adjustments/editing";

const INVENTORY_CONFIG = {
  resource: "inventories",
  resourceSingle: "inventory",

  userFacingText: {
    singular: "inventory",
    singularPossessive: "ingredient's",
    pluralPossessive: "ingredients'",
    inventoryTypeLabel: "RM",
  },

  onInit: () => {
    setupUnitChangeModal();
  },
};

onViewLoad("users#edit_inventory", () => {
  initializeInventoryAdjustPage(INVENTORY_CONFIG);
});
